<template>
	<div class="order-cancel-page">
		<!-- 背景圖片（置中） -->
		<div class="bg-image-wrapper">
			<img
				:src="require('@/assets/order_pending.svg')"
				alt=""
				class="bg-image"
			/>
		</div>
		<ByFooter />
	</div>
</template>

<script>
import store from '@/store'
import ByFooter from '@/components/Footer.vue'
import {
	cleanupExpiredTransactions,
	clearTransaction,
	isTransactionProcessed,
	markTransactionProcessed,
} from '@/utils/transactionGuard'

export default {
	name: 'OrderCancel',
	components: { ByFooter },
	// 路由守衛：防止用戶通過瀏覽器返回鍵回到此頁面
	beforeRouteEnter(to, from, next) {
		// 先清理過期的交易記錄
		cleanupExpiredTransactions()

		const { code, orderPaymentId } = to.query
		const storeHash = to.params.random

		// 如果缺少必要參數，說明是非正常進入（如：按返回鍵），拒絕進入
		if (!code || !orderPaymentId) {
			console.warn('[OrderCancel] 缺少必要參數，拒絕進入')
			// 設置待顯示的訊息到 store，然後阻止導航並重定向
			store.commit('setPendingAlert', {
				message: '取消付款參數錯誤',
				type: 'danger',
			})
			next({ path: `/${storeHash}/Store`, replace: true })
			return
		}

		// 檢查交易是否已處理過
		if (isTransactionProcessed(orderPaymentId)) {
			console.warn('[OrderCancel] 交易已處理，拒絕重複進入')
			// 設置待顯示的訊息到 store，然後阻止導航並重定向
			store.commit('setPendingAlert', {
				message: '此交易已處理，無法重複取消',
				type: 'warning',
			})
			next({ path: `/${storeHash}/Store`, replace: true })
			return
		}

		// 不在路由守衛階段標記交易，改為在 API 成功後才標記
		// 這樣失敗時用戶可以重試
		next()
	},
	data() {
		return {
			apiCalled: false, // 防重複調用標記（組件級）
			redirectPath: '', // 關閉後跳轉路徑
		}
	},
	created() {
		// 1. 防重複調用檢查（組件層級）
		if (this.apiCalled) {
			console.warn('[OrderCancel] API already called, skip')
			return
		}
		this.apiCalled = true

		// 2. 取得路由參數
		const storeHash = this.$storeManager.qrCodeHash
		const query = this.$route.query
		const orderPaymentId = query.orderPaymentId

		// 3. 立即標記交易為處理中，防止組件重複載入時的競態條件
		markTransactionProcessed(orderPaymentId)

		// 4. 使用全域 Loading 並取消付款交易
		this.$loading.show({
			message: '取消付款中...',
			successText: '取消付款成功',
			errorText: '取消付款失敗',
			resultDuration: 2000,
			onClose: () => this.handleRedirect(),
		})

		this.$api.order
			.cancelTransaction(query.code, {
				storeHash,
				...query,
			})
			.then(_ => {
				this.$loading.success()
				this.redirectPath = `/${storeHash}/Order`
			})
			.catch(err => {
				console.error('[OrderCancel] 取消付款失敗:', err)
				clearTransaction(orderPaymentId)
				this.$store.commit('user/SET_CART_ITEM', [])
				// 嘗試取得後端錯誤訊息
				const errorMessage =
					err?.response?.data?.message || err?.message || '取消付款出現異常!'
				this.$loading.error(errorMessage)
				this.redirectPath = `/${storeHash}/Store`
			})
	},
	methods: {
		handleRedirect() {
			if (this.redirectPath) {
				this.$router.replace(this.redirectPath)
			}
		},
	},
}
</script>

<style scoped>
.order-cancel-page {
	height: calc(100vh - 50px);
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	position: relative;
}

.bg-image-wrapper {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #ffffff;
}

.bg-image {
	max-width: 80%;
	max-height: 60%;
	object-fit: contain;
}
</style>
